export const VIEW_FIELD_KEYS = {
	TOURNAMENT_DETAILS: 'tournamentDetails',
	TYPE: 'name',
	TABLE_ID: 'tableId',
	IS_GOLD: 'isGold',
	ENTRY_FEE: 'entryFee',
	TOURNAMENT_START_TIME: 'tournamentStartTime',
	TOURNAMENT_END_TIME: 'tournamentEndTime',
	GAME_START_TIME: 'gameStartTime',
	GAME_END_TIME: 'gameEndTime',
	TOTAL_REGISTRATIONS: 'totalRegistrations',
	MINIMUM_PLAYERS: 'minimumPlayers',
	TOURNAMENT_STATUS: 'tournamentStatus',
	PRIZE_POT: 'prizePot',
	PAYOUT_DISTRIBUTION: 'payoutDistribution',
	USER_PAYMENT_TRANSACTION_ID: 'userPaymentTransactionId',
	SCORE: 'score',
	RANK: 'rank',
	MTT_RANK: 'mttRank',
	PAYMENT: 'payment',
	WINNINGS: 'winnings',
	REGISTERED_ON: 'registeredOn',
	JOINED_ON: 'joinedOn',
	JOIN_TYPE: 'joinType',
	FINAL_TOKEN_POSITIONS: 'finalTokenPositions',
	REFUNDED: 'refunded',
	REFUNDED_ON: 'refundedOn',
	STATUS_HISTORY: 'statusHistory',
	USER_GAME_DETAILS: 'userGameDetails',
	FINAL_RESULT_FOR_USER: 'finalResultForUser',
	BONUSMONEY: 'bonusCoins',
	DEPOSIT: 'deposit',
	MAXIMUM_PLAYERS: 'maximumPlayers',
	WINNING_AMOUNT: 'winningAmount',
	GAME_BOARD_TOKEN_POSITIONS: 'gameBoardTokenPositions'
};

export const EVENT_STATUS = {
	CLIENT_DISCONNECTED: 'client_disconnected',
	CLIENT_CONNECTED: 'client_connected'
};

export const REFUND_STATUSES = {
	REFUNDED: 'REFUNDED',
	NOT_REFUNDED: 'NOT_REFUNDED'
};
export const REFUND_STATUSES_LABEL = {
	[REFUND_STATUSES.REFUNDED]: 'YES',
	[REFUND_STATUSES.NOT_REFUNDED]: 'NO'
};

export const REFUND_STATUSES_MAP = {
	true: REFUND_STATUSES.REFUNDED,
	false: REFUND_STATUSES.NOT_REFUNDED
};

export const SHOW_OPPONENTS_GAME_DETAILS_GAME_LIST: string[] = ['ludo', 'snlt', 'turbo', 'ninja', 'tc', 'hc'];
